import React from "react";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
interface CustomPopoverProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  children: React.ReactNode;
}

const CustomPopover: React.FC<CustomPopoverProps> = ({ open, anchorEl, onClose, children }) => {
  const { t } = useTranslation();
  return (
    <Popover
      open={open}
      anchorEl={null}
      onClose={onClose}
      sx={{
        "& .MuiPaper-root": { borderRadius: "10px" },
      }}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'center',
        horizontal: 'center',
      }}
    >
      <div
        style={{
          padding: "10px",
          borderWidth: "1px",
          borderColor: "#CF0A2C",
          borderRadius: "10px",
          maxWidth: "300px",
          position: "relative",
        }}
      >
        {/* Titolo */}
        <Typography variant="h6" style={{ marginBottom: "10px", color: "#CF0A2C", fontWeight: "bold" }}>
        {t('screens.fleetAndRoute.errorDialog.noteTitle')}
        </Typography>

        {/* Icona "x" per chiudere */}
        <IconButton
          onClick={onClose}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            color: "#333333",
          }}
        >
          <CloseIcon />
        </IconButton>

        {/* Contenuto dinamico */}
        {children}
      </div>
    </Popover>
  );
};

export default CustomPopover;
